import { FC, useMemo } from 'react';

import classNames from 'classnames';

import Container, { ContainerProps } from '../Container';

import './Panel.scss';

import { TestMetadata } from '../types';

export interface PanelProps extends ContainerProps {
  /** Grid area name of Panel */
  name: string;
  /** Can choose to only show panel for specific sizes */
  visibleOn?: {
    size: 'slim' | 'small' | 'medium' | 'large' | 'wide';
    direction: 'up' | 'down';
  };
  /** Panel can scroll */
  isScrollable?: boolean;
  /** Set overflow: hidden */
  overflow?: 'visible' | 'hidden' | 'scroll' | 'auto';
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const Panel: FC<PanelProps> = ({
  children,
  className,
  style,
  name,
  visibleOn,
  testMetadata,
  isScrollable = true,
  overflow = 'visible',
  ...otherProps
}) => {
  const nameToken = useMemo((): Record<string, string> => {
    return {
      '--sb-panel-layout__panel-name': name,
    };
  }, [name]);

  return (
    <Container
      className={classNames(
        'sb-panel',
        visibleOn &&
          `sb-panel__visible-on-${visibleOn.size}-${visibleOn.direction}`,
        {
          'sb-panel_scrollable': isScrollable,
          [`sb-panel_${overflow}`]: overflow !== 'visible',
        },
        className,
      )}
      style={{ ...nameToken, ...style }}
      {...testMetadata}
      {...otherProps}
    >
      {children}
    </Container>
  );
};

export default Panel;
